import { call, put, select, takeLatest } from "redux-saga/effects";
import { fetchBusinessUnitAccountDetails } from "../../../services/accIqService";
import { FETCH_BUSINESS_UNIT_ACC_DETAILS_REQUEST, fetchBusinessUnitAccDetailFailure, fetchBusinessUnitAccDetailSuccess } from "../actions/businessUnitAccountDetailsActions";


// Worker Saga
function* fetchBusinessUnitAccDetailSaga() {
  try {
    const payload = yield select(state=>state?.businessUnitAccDetailsReducer?.payload);
    const {accountName, clientName, bu_unit} = payload;
    const data = yield call(fetchBusinessUnitAccountDetails,accountName, clientName, bu_unit);
    yield put(fetchBusinessUnitAccDetailSuccess(data));
  } catch (error) {
    yield put(fetchBusinessUnitAccDetailFailure(error.message));
  }
}

// Watcher Saga
export function* watchfetchBusinessUnitAccDetail() {
  yield takeLatest(FETCH_BUSINESS_UNIT_ACC_DETAILS_REQUEST, fetchBusinessUnitAccDetailSaga);
}
